// quick view 配置处理
import React, { useEffect } from 'react';

import Layout from '@/module/layout';

import Action from '@/component/module_actions';
import '@/component/module_drawer/index.less';
import Price from '@/component/module_price';
import QuickLeft from '@/component/module_quick_left';
import QuickRight from '@/component/module_quick_right';
import QuickBottom from '@/component/module_quick_right/bottom';
import QuickHeader from '@/component/module_quick_right/header';
import TaPlus from '@/component/module_ta-semi';

import { getModuleData } from '@/common/data';
import { postLoad } from '@/common/iframe-post';
import isNodeServer from '@/utils/isNodeServer';

const Components = {
  Price,
  QuickLeft,
  QuickRight,
  TaPlus,
} as unknown as {
  [key: string]: () => React.JSX.Element;
};

export default function Quick(props: DetailTypes.Root) {
  const { globalData } = props;

  useEffect(() => {
    // loading 消息同步
    if (!isNodeServer()) {
      document.addEventListener('DOMContentLoaded', postLoad);
      return () => {
        document.removeEventListener('DOMContentLoaded', postLoad);
      };
    }
  }, []);

  return (
    <>
      <QuickHeader i18n={globalData.i18n} />
      <Layout {...props} components={Components} />
      <QuickBottom i18n={globalData.i18n} abtest={globalData.abtest}>
        <Action
          {...(getModuleData('module_quick_right', props) as any)}
          renderConfig={{
            showType: 'quick',
            testType: 'quick',
          }}
        />
      </QuickBottom>
    </>
  );
}
